import { ReactNode } from 'react';

export function AuthShell({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}) {
  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-12">
      <div
        className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-[600px]"
        style={{
          background:
            'radial-gradient(circle at 50% 0%, rgba(59,130,246,0.12) 0%, transparent 60%)',
        }}
      />
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="text-2xl font-extrabold tracking-tight">
            Score<span className="text-brand">Lync</span>
          </div>
        </div>
        <div className="card">
          <h1 className="text-xl font-semibold">{title}</h1>
          {subtitle && (
            <p className="mt-1 text-sm text-muted">{subtitle}</p>
          )}
          <div className="mt-6">{children}</div>
        </div>
      </div>
    </div>
  );
}
